import { render } from "./TodoView.vue?vue&type=template&id=6294f45e&scoped=true&ts=true"
import script from "./TodoView.vue?vue&type=script&lang=ts"
export * from "./TodoView.vue?vue&type=script&lang=ts"

import "./TodoView.vue?vue&type=style&index=0&id=6294f45e&scoped=true&lang=css"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6294f45e"]])

export default __exports__